import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhoneMissedComponent } from "./med-icon-phone-missed.component";

@NgModule({
  declarations: [
    MedIconPhoneMissedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhoneMissedComponent,
  ],
})
export class MedIconPhoneMissedModule { }
